import React from 'react';

const Header = () => {
  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <a className="navbar-brand" href="#/"><img src="image/logo2.png" className="card-img-top" alt="..." /></a>
       
      </nav>
    </header>
  );
}

export default Header;